var _circle, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLedRetrofit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83,
    height: 83,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 41.5,
    r: 41.5,
    fill: "#6C5AFC",
    fillOpacity: 0.15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#led-retrofit_svg__clip0_2636_4930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.696 45.2A1.303 1.303 0 0160 46.512v5.927a1.304 1.304 0 01-1.295 1.312 1.303 1.303 0 01-1.295-1.312v-2.081C54.041 56.01 47.788 60 41.05 60c-8.158 0-14.996-5.034-17.961-12.793a1.317 1.317 0 01.74-1.696 1.292 1.292 0 011.676.749c2.59 6.775 8.488 11.119 15.546 11.119 6.236 0 12.061-4.037 14.775-9.535l-2.72.018A1.302 1.302 0 0151.8 46.56a1.304 1.304 0 011.286-1.321l5.609-.039zM41.953 23c8.155 0 14.994 5.034 17.96 12.793a1.317 1.317 0 01-.74 1.696 1.288 1.288 0 01-1.676-.749c-2.59-6.775-8.488-11.119-15.546-11.119-6.236 0-12.062 4.037-14.776 9.535l2.722-.018A1.302 1.302 0 0131.2 36.44a1.304 1.304 0 01-1.286 1.321l-5.61.039A1.303 1.303 0 0123 36.488v-5.927c0-.725.58-1.312 1.295-1.312.714 0 1.295.587 1.295 1.312v2.081C28.959 26.99 35.212 23 41.95 23h.003z",
    fill: "#6C5AFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "led-retrofit_svg__clip0_2636_4930"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(23 23)",
    d: "M0 0h37v37H0z"
  })))));
}

export default SvgLedRetrofit;